import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogConfig } from './message-dialog-config.interface';

@Component({
    selector: 'ca-error-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrl: './message-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MessageDialogComponent {
    public dialogRef = inject<MatDialogRef<MessageDialogComponent>>(MatDialogRef);
    public data = inject<MessageDialogConfig>(MAT_DIALOG_DATA);

    public onCancel(): void {
        this.dialogRef.close({ cancel: true });
    }
}
